/**
 * Internal dependencies
 */
import ACCOUNT_ACTION from '@naruto/bgdcms/src/reducers/cores/account/events';
import {
  SetAccountContentInitialAction,
  SetAccountListAction,
  SetAccountInfoAction,
  AccountList,
  AccountListCondition,
  AccountInfo
} from './types';

/* Initial */
export const SET_ACCOUNT_INITIALIZE = (): SetAccountContentInitialAction => ({
  type: ACCOUNT_ACTION.SET_ACCOUNT_INITIALIZE
});

/* Account Action */
export const SET_ACCOUNT_LIST = ({
  list,
  condition
}: {
  list: AccountList;
  condition: AccountListCondition;
}): SetAccountListAction => ({
  type: ACCOUNT_ACTION.SET_ACCOUNT_LIST,
  list,
  condition
});
export const SET_ACCOUNT_INFO = ({
  accountID,
  accountInfo
}: {
  accountID: string;
  accountInfo: AccountInfo;
}): SetAccountInfoAction => ({
  type: ACCOUNT_ACTION.SET_ACCOUNT_INFO,
  accountID,
  accountInfo
});
